(function (module) {
    "use strict";

    module.service('mkrshCalculatorService', ['$rootScope', function(this: $TSFixMe, $rootScope: ng.IRootScopeService) {
        var service = this;


        service.multiplieByMksrh = function (mkshr: $TSFixMe, pmForecast: $TSFixMe, statisticalForecast: $TSFixMe, pmForecastOutput: $TSFixMe, statisticalForecastOutput: $TSFixMe) {

            if (pmForecast.length < pmForecastOutput.length) {
                pmForecastOutput.splice(0, pmForecastOutput.length - pmForecast.length);
            }

            if (pmForecast.length < statisticalForecastOutput.length) {
                statisticalForecastOutput.splice(0, statisticalForecastOutput.length - pmForecast.length);
            }

            for (var i = 0; i < pmForecast.length; i++) {
                var monthMkshr = mkshr[i];
                pmForecastOutput[i] = monthMkshr == null ? null : pmForecast[i] * (monthMkshr / 100.0);
                statisticalForecastOutput[i] = monthMkshr == null ? null : statisticalForecast[i] * (monthMkshr / 100.0);
            }
        }
    }]);


})(angular.module('topline.services'));